import { User } from "./user.model";

export class Client extends User {
  org: string;
}